import styled from "styled-components";

export const VideoSecWrapper = styled.div`
  .video_play_box {
    position: relative;
    border-radius: 25px;
    overflow: hidden;
    @media (max-width: 1199px) {
      border-radius: 15px;
    }
    @media (max-width: 899px) {
      border-radius: 12px;
    }
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 166px;
      left: 0;
      bottom: 0;
      z-index: 1;
      background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
    }
    figure {
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .playBtn_icon {
      width: 73px;
      height: 73px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 3;
      @media (max-width: 1199px) {
        width: 50px;
        height: 50px;
      }
      @media (max-width: 599px) {
        width: 40px;
        height: 40px;
      }
    }
  }
`;

export const TeamsCollaborationSecWrapper = styled.div`
  .collaboration_row {
    align-items: center;
    margin: -10px;
    .col {
      width: 50%;
      padding: 10px;
      @media (max-width: 899px) {
        width: 100%;
      }
      figure {
        @media (max-width: 899px) {
          max-width: 60%;
          margin: 0 auto;
        }
      }
    }
  }
`;
